import { Mixins, Component, Prop } from 'vue-property-decorator';
import MoreBadge from '@/components/parts/slider/badges/Badges.vue';
import Common from '../common';
import MoreTitle from '../components/Title.vue';
import MoreNote from '../components/Note.vue';
import MorePrice from '../components/Price.vue';
import MoreButton from '../components/More.vue';
import Locked from '../components/Locked.vue';
import ScheduleDate from '@/components/parts/catalog/list/item/components/ScheduleDate.vue';
import AppSvgIcon from '@/uikit/components/AppSvgIcon/AppSvgIcon.vue';

@Component({
  components: {
    AppSvgIcon,
    ScheduleDate,
    MoreBadge,
    MoreTitle,
    MoreNote,
    MorePrice,
    MoreButton,
    Locked,
  },
})
export default class ComponentPartCatalogListSingle extends Mixins(Common) {
  @Prop({ type: Boolean, default: false })
  hideButton?: boolean;

  check = false;

  get imgClass() {
    const { imageBgDefault, imageBgSize } = this;
    return {
      [`single-card__img_${imageBgSize}`]: true,
      'single-card__img_default': imageBgDefault,
    };
  }

  get getMultiCopStyle() {
    if (this.cop_multi_name) {
      return {
        'margin-top': '114px',
      };
    }
  }

  get copMultiDict() {
    return this.$store.state.copMultiDict;
  }

  get cancel() {
    const { status } = this;
    return status === 'Новая' || status === 'Отложена';
  }

  get statusType() {
    const { status, pfdodUrl } = this;
    const isStatus =
      status === 'Новая' || status === 'Отложена' || status === 'Подтверждена';
    if (status === 'Подтверждена') return isStatus && !!pfdodUrl;
    return isStatus;
  }

  emitIds() {
    const { statusType, $router, to } = this;
    if (statusType) $router.push(to);
  }

  GoToCard() {
    const { statusType, $router, to } = this;
    if (statusType) $router.push(to);
  }

  get variantClass() {
    const { variant } = this;
    return variant ? `variant_${variant}` : false;
  }

  get pfdodUrl() {
    const { pfdod_contracts } = this.$attrs;
    const isPfdod = pfdod_contracts && pfdod_contracts.length;
    return isPfdod ? pfdod_contracts[0] : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/parts/catalog/list/item/single/script.ts